module.exports = __webpack_public_path__ + "static/img/feedback-bad.cd73a7aa.jpg";